import EventEmitter from 'eventemitter3';
import {
  ISSUE_CREATE_API_FULFILLED,
  ISSUE_UPDATE_API_FULFILLED,
  PUSHPIN_WORKFLOW_BEGIN,
  PUSHPIN_WORKFLOW_END,
  OPEN_ATTACHMENT,
  TOKEN_EXPIRED,
  ROUTE_CHANGE,
  SHEET_CHANGE,
  CLOSE_ISSUE_DETAILS_MODAL_VIEW,
  HANDLE_NAVIGATE_TO_ISSUE_IN_DOCUMENT,
  SCROLL_DOWN
} from '../app/actions';

const supportedEvents = {
  ISSUE_CREATE_API_FULFILLED,
  ISSUE_UPDATE_API_FULFILLED,
  PUSHPIN_WORKFLOW_BEGIN,
  PUSHPIN_WORKFLOW_END,
  OPEN_ATTACHMENT,
  GROWL_ALERT: 'GROWL_ALERT',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  TOKEN_EXPIRED,
  ROUTE_CHANGE,
  SHEET_CHANGE,
  CLOSE_ISSUE_DETAILS_MODAL_VIEW,
  HANDLE_NAVIGATE_TO_ISSUE_IN_DOCUMENT,
  SCROLL_DOWN
};

const deprecatedEvents = [supportedEvents.GROWL_ALERT, supportedEvents.SHOW_NOTIFICATION];

export default class {
  constructor() {
    this.emitter = new EventEmitter();
  }

  static get events() {
    return supportedEvents;
  }

  emit(type, ...args) {
    // 1st argument to emitter.emit is the event type.
    // subsequent arguments are data, that are passed to listeners.
    this.emitter.emit(type, ...args);
  }

  listenerCount(eventName) {
    return this.emitter.listeners(eventName).length;
  }

  // eslint-disable-next-line consistent-return
  on(eventName, callback) {
    if (deprecatedEvents.includes(eventName)) {
      /* eslint-disable no-console */
      console.warn(`Event ${eventName} is deprecated`);
      /* eslint-enable no-console */
    }

    const {events} = this.constructor;
    if (events.hasOwnProperty(eventName)) {
      const unsubscribe = () => {
        this.emitter.removeListener(eventName, callback);
      };
      this.emitter.on(eventName, callback);
      return unsubscribe;
    } else {
      /* eslint-disable no-console */
      console.warn(`Event "${eventName}" is not available in: ${JSON.stringify(Object.keys(events))}`);
      /* eslint-enable no-console */
    }
  }
}
